import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { CoreBase, ICoreBase } from './CoreBase'

export class MotivoTransferenciaReserva extends CoreBase implements IMotivoTransferenciaReserva {
  async getMotivosTransferenciaReservaByHospital(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getMotivosTransferenciaReservaByHospital(params)
    return response
  }

  async cadastrar(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarMotivoTransferenciaReserva(params)
    return response
  }

  async atualizar(params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.atualizarMotivoTransferenciaReserva(params)
    return response
  }
}

export interface IMotivoTransferenciaReserva extends ICoreBase {
  getMotivosTransferenciaReservaByHospital(params: any): Promise<ResponseApi>
  cadastrar(params: any): Promise<ResponseApi>
  atualizar(params: any): Promise<ResponseApi>
}
